import { Box } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import React from 'react';
import CustomPagination from '../../../components/reusable-ui/custom-pagination';
import { DATE_TIME_FORMATS } from '../../../data/constants';
import { isMobileDevice } from '../../../helpers/device-info-helper';
import { dataGridStyle } from '../../downloads/components';
const Settlements = (props: any) => {
  const tableTab = props.status;
  const rowData = props.data.map(handleData);

  const subTabs = [
    { id: 'Open', name: 'Open Balance' },
    { id: 'Closed', name: 'Closed Balance' },
    { id: 'Due', name: 'Balance Due' },
  ];

  function handleData(data: any) {
    data['deviceLabel'] = data.openInfo?.deviceInfo?.label;
    data['deviceNo'] = data.openInfo?.deviceInfo?.serialNumber;
    data['startTime'] = moment(data.startTime).format(
      DATE_TIME_FORMATS.yearMonthDayTime
    );
    data['endTime'] = moment(data?.endTime)?.format(
      DATE_TIME_FORMATS.yearMonthDayTime
    );
    return data;
  }

  const row: any = {};
  const data = { rows: [row] };
  type Row = (typeof data.rows)[number];
  const tableColumns =  [
      {
        field: 'userInfo',
        headerName: 'User Name',
        width: 200,
        renderCell: (value: any) => value?.value?.userName?.firstName || '',
      },
      {
        field: 'deviceNo',
        headerName: 'Device No.',
        width: 170,
      },
      {
        field: 'settlementNumber',
        headerName: 'Transaction No.',
        width: 200,
      },
      {
        field: 'deviceLabel',
        headerName: 'Device Label',
        width: 190,
      },
      {
        field: 'startTime',
        headerName: 'Shift start time',
        width: 250,
      },
      {
        field: 'endTime',
        headerName: 'Shift end time',
        width: 250,
        hide : tableTab !== "Closed"
      },
      {
        field: 'status',
        headerName: 'Status',
        width: 150,
      },
      // {
      //   field: 'openBal',
      //   headerName: 'Opening balance',
      //   width: 160,
      // },
      // {
      //   field: 'collection',
      //   headerName: 'Collection',
      //   width: 120,
      // },
      {
        field: 'balanceStatus',
        headerName: '',
        width: 140,
        renderCell: (value: any) =>
          value?.value && (
            <div className="bg-[#FCF0BE] text-[#99811F] text-10 font-medium p-8 rounded-[6px]">
              Balance Due
            </div>
          ),
      },
    ];

  function renderTableHeader() {
    return (
      <div className="flex pt-[23px] text-16 border-b-[1px] sm:min-w-[363px] overflow-x-auto">
        {subTabs.map((value) => {
          return (
            <div
              className={`${
                tableTab === value.id
                  ? 'text-[#397EF5] font-medium border-b-[3px] border-[#397EF5]'
                  : 'text-black/50 border-b-[3px] border-transparent'
              } pl-24 pr-20 sm:px-10 cursor-pointer pb-17 sm:text-[14px]`}
              onClick={() => props.handleStatus(value.id)}
            >
              {value.name}
            </div>
          );
        })}
      </div>
    );
  }
  function pagination() {
    return (
      <CustomPagination
        parentClass="w-[100%] pt-5 h-50 sm:px-16"
        prevPagination={props.prevPagination}
        paginationData={props.paginationData}
        nextCta={{ text: 'Next', customClass: 'ml-10' }}
        prevCta={{ text: 'Prev', customClass: 'ml-auto' }}
        getDataFn={props.getSettlements}
      />
    );
  }

  function emptyFooter() {
    return <></>;
  }

  function renderMobileData() {
    return (
      <div>
        {rowData.map((value: any) => {
          let dateTime = value.startTime;
          return (
            <div
              onClick={() => {
                props.toggleViewSettlement(value._id);
              }}
              className="flex flex-col text-black px-16 pt-16 pb-20 border-b-[3px]"
            >
              <div className="flex justify-between">
                <div className=" font-medium text-[15px] ">
                  {value?.userInfo?.userName?.firstName}
                </div>
                <div className="text-black/[0.48] text-[11px] max-w-[69px] break-words flex flex-col ">
                  <div>
                    {moment(dateTime).format(DATE_TIME_FORMATS.dayMonthYear)}
                  </div>
                  <div className="flex ml-auto">
                    {' '}
                    {moment(dateTime).format(DATE_TIME_FORMATS.time)}
                  </div>
                </div>
              </div>
              <div className="flex justify-between ">
                <div className="text-[13px] font-normal">
                  <span className="opacity-70">Device No.:</span>
                  {value?.openInfo?.deviceInfo?.serialNumber}
                </div>
              </div>
              <div className="flex justify-between mt-6">
                <div className="text-[12px] font-medium text-black/70">
                  Balance
                </div>
                <div className="font-medium text-10 bg-[#FCF0BE] text-[#99811F] px-8 py-4 rounded-[4px]">
                  BALANCE DUE
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  function renderTable() {
    return (
      <>
        {isMobileDevice() ? (
          renderMobileData()
        ) : (
          <Box sx={dataGridStyle}>
            <DataGrid
              rows={rowData}
              columns={tableColumns}
              getRowId={(row: any) => row?._id}
              disableColumnMenu
              disableSelectionOnClick
              onRowClick={(value: any) => props.toggleViewSettlement(value.id)}
              components={{
                Footer: emptyFooter,
              }}
            />
          </Box>
        )}
        {(props.data?.length > 0 || props?.prevPagination?.length > 0) &&
          pagination()}
      </>
    );
  }

  return (
    <div className="m-20 sm:m-0 bg-white">
      {renderTableHeader()}
      {renderTable()}
    </div>
  );
};
export default Settlements;
